'use strict';

const _=require('pulsar-utils/dist-es6/_');
const fastdom=require('fastdom');
const BaseDirective=require('../../../dist-es6/client/angularCommon/baseDirective');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const Formatters=require('../../../dist-es6/client/formatters');let

DurationDirective=class DurationDirective extends BaseDirective{
get restrict(){
return'A';
}

get objectBindings(){
return['hours'];
}

link($scope,$element){
let updateTime=()=>{
fastdom.mutate(()=>{
if(!_.exists($scope.hours)){
angular.element($element[0]).text('--');
return;
}

angular.element($element[0]).text(`${Formatters.timeSpanAsHoursAndMinutes(timespan.fromHours($scope.hours))}`);
});
};

$scope.$watch('hours',updateTime);

updateTime();
}};


module.exports=DurationDirective;
//# sourceMappingURL=durationDirective.js.map
